<script setup lang="ts">
import { MMButton, usePopups } from '@mm-frontend/mm-web-ui-kit';
import DevToolbarModal from './DevToolbarModal.vue';
import { DebugContainer } from './debug-ui';
import { useDevToolbar } from '../business/form';
import { useAuthSDK } from '~/features/auth-sdk';

const { isApiSwitched } = useDevToolbar();
const { logout } = useAuthSDK();
const { createPopup } = usePopups();
const popup = createPopup({
  component: DevToolbarModal,
});

popup.onClose((hasUpdates) => {
  if (!hasUpdates) return;

  if (isApiSwitched.value) logout();

  location.reload();
});
</script>

<template>
  <MMButton
    :prefix-icon="{ name: 'settings-outlined', height: 24, width: 24 }"
    design="TertiaryGhost"
    round
    title="Настройки окружения"
    class="dev-toolbar-button"
    @click="popup.show()"
  />

  <DebugContainer />
</template>

<style scoped lang="stylus">
.dev-toolbar-button
  position fixed
  z-index 499
  top 50%
  transform translateY(-50%)
  right 4px
  opacity .4
</style>
